<template>
    <div>
        <div class="header">
            <div class="step-ttl">اطلاعات اولیه</div>
            <div class="h-border"></div>
            <div class="step">مرحله 1-4</div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label>نام:</label>
                    <input type="text"
                           v-model.trim="personalInfo.firstName"
                           @input="$v.personalInfo.firstName.$touch()"
                           :class="[$v.personalInfo.firstName.$error?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.firstName.$error && !$v.personalInfo.firstName.required">لطفا نام خود را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>نام‌خانوادگی:</label>
                    <input type="text"
                           v-model.trim="personalInfo.lastName"
                           @input="$v.personalInfo.lastName.$touch()"
                           :class="[$v.personalInfo.lastName.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.lastName.$error && !$v.personalInfo.lastName.required">لطفا نام خانوادگی خود را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>نام پدر‌:</label>
                    <input type="text"
                           v-model.trim="personalInfo.familyInfo.fatherName"
                           @input="$v.personalInfo.familyInfo.fatherName.$touch()"
                           :class="[$v.personalInfo.familyInfo.fatherName.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.familyInfo.fatherName.$error && !$v.personalInfo.familyInfo.fatherName.required">لطفا نام پدر خود را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>تاریخ تولد:</label>
                    <input type="text"
                           v-model.trim="personalInfo.birthDate"
                           @input="$v.personalInfo.birthDate.$touch()"
                           placeholder="مثال: 1370/08/15"
                           :class="[$v.personalInfo.birthDate.$error  ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.birthDate.$error && !$v.personalInfo.birthDate.required">لطفا تاریخ تولد خود را وارد کنید.</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label>شماره شناسنامه:</label>
                    <input type="text"
                           v-model.trim="personalInfo.birthCertificateNumber"
                           @input="$v.personalInfo.birthCertificateNumber.$touch()"
                           :class="[$v.personalInfo.birthCertificateNumber.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.birthCertificateNumber.$error && !$v.personalInfo.birthCertificateNumber.required">لطفا شماره شناسنامه خود را وارد کنید.</span>
                    <span class="help-block" v-if="$v.personalInfo.birthCertificateNumber.$error && !$v.personalInfo.birthCertificateNumber.numeric"> شماره شناسنامه نامعتبر می باشد.</span>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>کدملی:</label>
                    <input type="text"
                           v-model.trim="personalInfo.ssn"
                           @input="$v.personalInfo.ssn.$touch()"
                           :class="[$v.personalInfo.ssn.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.ssn.$error && !$v.personalInfo.ssn.required">لطفا کدملی خود را وارد کنید.</span>
                    <span class="help-block" v-if="$v.personalInfo.ssn.$error && !$v.personalInfo.ssn.numeric"> کدملی نامعتبر می باشد.</span>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>محل‌ تولد‌:</label>
                    <input type="text"
                           v-model.trim="personalInfo.placeOfBirth"
                           @input="$v.personalInfo.placeOfBirth.$touch()"
                           :class="[$v.personalInfo.placeOfBirth.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.placeOfBirth.$error && !$v.personalInfo.placeOfBirth.required">لطفامحل‌ تولد خود را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>محل‌ صدور‌:</label>
                    <input type="text"
                           v-model.trim="personalInfo.placeOfIssueBirthCertificate"
                           @input="$v.personalInfo.placeOfIssueBirthCertificate.$touch()"
                           :class="[$v.personalInfo.placeOfIssueBirthCertificate.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.placeOfIssueBirthCertificate.$error && !$v.personalInfo.placeOfIssueBirthCertificate.required">لطفامحل‌ صدور شناسنامه خود را وارد کنید.</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="d-block">جنسیت‌:</label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" v-model="personalInfo.gender" type="radio" value="1" id="female" @change="changeGender()">
                        <label for="female">مونث</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" v-model="personalInfo.gender" type="radio" value="0" id="male" @change="changeGender()">
                        <label for="male">مذکر</label>
                    </div>
                </div>
                <span class="help-block" v-if="$v.personalInfo.gender.$error && !$v.personalInfo.gender.required">لطفا جنسیت خود را انتخاب نمایید.</span>
            </div>
            <div class="col-md-9">
                <div class="row custom-side-margin" v-if="personalInfo.gender==0">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="d-block">وضعیت خدمت‌:</label>
                            <div class="d-inline-block">
                                <input class="custom-input-button" type="radio" v-model="personalInfo.militaryServiceInfo.militaryCondition" value="0" id="پايان خدمت">
                                <label for="پايان خدمت">پايان خدمت</label>
                            </div>
                            <div class="d-inline-block">
                                <input class="custom-input-button" type="radio" v-model="personalInfo.militaryServiceInfo.militaryCondition" value="1" id="خرید خدمت">
                                <label for="خرید خدمت">
                                    خرید خدمت
                                </label>
                            </div>
                            <div class="d-inline-block">
                                <input class="custom-input-button" type="radio" v-model="personalInfo.militaryServiceInfo.militaryCondition" value="2" id="معافیت">
                                <label for="معافیت">معافیت</label>
                            </div>
                            <span class="help-block d-block" v-if="$v.personalInfo.militaryServiceInfo.militaryCondition.$error && $v.personalInfo.militaryServiceInfo.militaryCondition.$invalid">لطفا وضعیت خدمت خود را انتخاب نمایید.</span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="d-block">آیا دارای مدرک معافیت هستید؟‌</label>
                            <div class="d-inline-block">
                                <input class="custom-input-button" type="radio" v-model="personalInfo.militaryServiceInfo.hasExemptionDocument" value="true" id="yes">
                                <label for="yes">بلی</label>
                            </div>
                            <div class="d-inline-block">
                                <input class="custom-input-button" type="radio" v-model="personalInfo.militaryServiceInfo.hasExemptionDocument" value="false" id="no">
                                <label for="no">خیر</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4" v-if="personalInfo.militaryServiceInfo.hasExemptionDocument=='true'">
                        <div class="form-group">
                            <label>نوع معافیت:</label>
                            <input type="text"
                                   v-model="personalInfo.militaryServiceInfo.exemptionType"
                                   :class="[$v.personalInfo.militaryServiceInfo.exemptionType.$error ?'error-input' :'','form-control']">
                            <span class="help-block" v-if="$v.personalInfo.militaryServiceInfo.exemptionType.$error && $v.personalInfo.militaryServiceInfo.exemptionType.$invalid">لطفا نوع معافیت خود را وارد کنید.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="d-block">وضعیت تاهل‌:</label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="personalInfo.familyInfo.maritalStatus" value="1" id="singel" @change="changeMaritalStatus">
                        <label for="singel">مجرد</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="personalInfo.familyInfo.maritalStatus" value="0" id="married" @change="changeMaritalStatus">
                        <label for="married">متاهل</label>
                    </div>
                </div>
                <span class="help-block" v-if="$v.personalInfo.familyInfo.maritalStatus.$error && !$v.personalInfo.familyInfo.maritalStatus.required">لطفا وضعیت تاهل خود را انتخاب نمایید.</span>
            </div>
            <div class="col-md-9">
                <div class="row custom-side-margin" v-if="personalInfo.familyInfo.maritalStatus==0">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>نام و نام خانوادگي همسر:</label>
                            <input type="text"
                                   v-model="personalInfo.familyInfo.spouseName"
                                   :class="[$v.personalInfo.familyInfo.spouseName.$error ?'error-input' :'','form-control']">
                            <span class="help-block" v-if="$v.personalInfo.familyInfo.spouseName.$error && $v.personalInfo.familyInfo.spouseName.$invalid">لطفا نام و نام خانوادگي همسر خود را وارد کنید.</span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>شغل همسر:</label>
                            <input type="text"
                                   v-model="personalInfo.familyInfo.spouseJob"
                                   :class="[$v.personalInfo.familyInfo.spouseJob.$error ?'error-input' :'','form-control']">
                            <span class="help-block" v-if="$v.personalInfo.familyInfo.spouseJob.$error && $v.personalInfo.familyInfo.spouseJob.$invalid">لطفا شغل همسر خود را وارد کنید.</span>
                        </div>
                    </div>
                    <div class="col-md-4" >
                        <div class="form-group">
                            <label>تلفن محل كار همسر:</label>
                            <input class="form-control" type="text" v-model="personalInfo.familyInfo.spouseWorkplacePhoneNumber">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label>تعداد افراد تحت تكفل:</label>
                    <input type="text"
                           v-model.trim="personalInfo.familyInfo.numberOfUnderTheTutelagePeople"
                           @input="$v.personalInfo.familyInfo.numberOfUnderTheTutelagePeople.$touch()"
                           :class="[$v.personalInfo.familyInfo.numberOfUnderTheTutelagePeople.$error?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.familyInfo.numberOfUnderTheTutelagePeople.$error && !$v.personalInfo.familyInfo.numberOfUnderTheTutelagePeople.required">لطفا تعداد افراد تحت تكفل را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>تعداد فرزندان :</label>
                    <input type="text"
                           v-model.trim="personalInfo.familyInfo.numberOfChildren"
                           @input="$v.personalInfo.familyInfo.numberOfChildren.$touch()"
                           :class="[$v.personalInfo.familyInfo.numberOfChildren.$error?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.familyInfo.numberOfChildren.$error && !$v.personalInfo.familyInfo.numberOfChildren.required">لطفا تعداد فرزندان را وارد کنید.</span>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label class="d-block">نوع مالكیت محل سكونت‌:</label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="personalInfo.residenceInfo.typeOfOwnershipOfTheResidence" value="1" id="شخصی" @change="changeTypeOfOwnershipOfTheResidence">
                        <label for="شخصی">شخصی</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="personalInfo.residenceInfo.typeOfOwnershipOfTheResidence" value="0" id="استیجاری" @change="changeTypeOfOwnershipOfTheResidence">
                        <label for="استیجاری">استیجاری</label>
                    </div>
                </div>
                <span class="help-block d-block" v-if="$v.personalInfo.residenceInfo.typeOfOwnershipOfTheResidence.$error && !$v.personalInfo.residenceInfo.typeOfOwnershipOfTheResidence.required">لطفا نوع مالكیت محل سكونت را انتخاب نمایید.</span>
            </div>
            <div class="col-md-3" v-if="personalInfo.residenceInfo.typeOfOwnershipOfTheResidence==0">
                <div class="form-group">
                    <label>مبلغ اجاره:</label>
                    <input type="text"
                           v-model.trim="personalInfo.residenceInfo.rentAmount"
                           @input="$v.personalInfo.residenceInfo.rentAmount.$touch()"
                           :class="[$v.personalInfo.residenceInfo.rentAmount.$error?'error-input' :'','form-control']">
                    <span class="help-block d-block" v-if="$v.personalInfo.residenceInfo.rentAmount.$error && $v.personalInfo.residenceInfo.rentAmount.$invalid">لطفا مبلغ اجاره را وارد نمایید.</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label>تلفن منزل:</label>
                    <input type="text"
                           v-model.trim="personalInfo.residenceInfo.phoneNumber"
                           @input="$v.personalInfo.residenceInfo.phoneNumber.$touch()"
                           :class="[$v.personalInfo.residenceInfo.phoneNumber.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.residenceInfo.phoneNumber.$error && !$v.personalInfo.residenceInfo.phoneNumber.required">لطفا تلفن منزل را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>تلفن همراه:</label>
                    <input type="text"
                           v-model.trim="personalInfo.contactInfo.phoneNumber"
                           @input="$v.personalInfo.contactInfo.phoneNumber.$touch()"
                           :class="[$v.personalInfo.contactInfo.phoneNumber.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.contactInfo.phoneNumber.$error && !$v.personalInfo.contactInfo.phoneNumber.required">لطفا تلفن همراه خود را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>تلفن ديگر تماس:</label>
                    <input class="form-control" type="text" v-model="personalInfo.contactInfo.secondaryPhoneNumber">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>پست الكترونیكی‌:</label>
                    <input type="text"
                           v-model.trim="personalInfo.contactInfo.email"
                           @input="$v.personalInfo.contactInfo.email.$touch()"
                           :class="[$v.personalInfo.contactInfo.email.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.contactInfo.email.$error && !$v.personalInfo.contactInfo.email.required">لطفا پست الكترونیكی خود را وارد کنید.</span>
                    <span class="help-block" v-if="$v.personalInfo.contactInfo.email.$error && !$v.personalInfo.contactInfo.email.email"> پست الكترونیكی نامعتبر می باشد.</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label>نشانی كامل محل سكونت:</label>
                    <input type="text"
                           v-model.trim="personalInfo.residenceInfo.address"
                           @input="$v.personalInfo.residenceInfo.address.$touch()"
                           :class="[$v.personalInfo.residenceInfo.address.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.residenceInfo.address.$error && !$v.personalInfo.residenceInfo.address.required">لطفا نشانی كامل محل سكونت خود را وارد کنید.</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="d-block">
                        آيا تاكنون در استخدام اين شركت بوده ايد و يا در اين شركت مصاحبه استخدامی داشته ايد؟‌
                    </label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="personalInfo.pastRelationWithCompany.hasRelation" value="true" id="interviewed" @change="changePastRelationWithCompany">
                        <label for="interviewed">بلی</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="personalInfo.pastRelationWithCompany.hasRelation" value="false" id="not_interviewed" @change="changePastRelationWithCompany">
                        <label for="not_interviewed">خیر</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="personalInfo.pastRelationWithCompany.hasRelation=='true'">
            <div class="col-md-12">
                <div class="form-group">
                    <label> تاريخ ها و سوابق را ذكر كنید:</label>
                    <input type="text"
                           v-model="personalInfo.pastRelationWithCompany.description"
                           :class="[$v.personalInfo.pastRelationWithCompany.description.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.pastRelationWithCompany.description.$error && $v.personalInfo.pastRelationWithCompany.description.$invalid">لطفا تاريخ ها و سوابق را ذكر كنید.</span>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="d-block">
                        آيا تاكنون محكوميت كيفري داشته ايد ؟
                    </label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="personalInfo.criminalConviction.hasCriminalConviction" value="true" id="convicted" @change="changeCriminalConviction">
                        <label for="convicted">بلی</label>
                    </div>
                    <div class="d-inline-block">

                        <input class="custom-input-button" type="radio" v-model="personalInfo.criminalConviction.hasCriminalConviction" value="false" id="not_convicted" @change="changeCriminalConviction">
                        <label for="not_convicted">خیر</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="personalInfo.criminalConviction.hasCriminalConviction=='true'">
            <div class="col-md-12">
                <div class="form-group">
                    <label>نوع محكوميت:</label>
                    <input  type="text" 
                            v-model="personalInfo.criminalConviction.description"
                            :class="[$v.personalInfo.criminalConviction.description.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.personalInfo.criminalConviction.description.$error && $v.personalInfo.criminalConviction.description.$invalid">لطفا نوع محكوميت خود را توضیح دهید.</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, email, numeric, requiredIf } from "vuelidate/lib/validators";
    import Vue from 'vue'
    import Vuelidate from 'vuelidate'
    Vue.use(Vuelidate)
    export default {
        data() {
            return {
                personalInfo: {
                    firstName: "",
                    lastName: "",
                    birthCertificateNumber: "",
                    ssn: "",
                    placeOfBirth: "",
                    placeOfIssueBirthCertificate: "",
                    gender: null,
                    birthDate: "",
                    age: null,
                    militaryServiceInfo: {
                        hasExemptionDocument: false,
                        exemptionType: "",
                        militaryCondition: null
                    },
                    familyInfo: {
                        fatherName: "",
                        maritalStatus: null,
                        spouseName: "",
                        spouseJob: "",
                        spouseWorkplacePhoneNumber: "",
                        numberOfChildren: null,
                        numberOfUnderTheTutelagePeople: null
                    },
                    residenceInfo: {
                        address: "",
                        phoneNumber: "",
                        typeOfOwnershipOfTheResidence: null,
                        rentAmount: null
                    },
                    contactInfo: {
                        phoneNumber: "",
                        secondaryPhoneNumber: "",
                        email: ""
                    },
                    pastRelationWithCompany: {
                        hasRelation: false,
                        description: ""
                    },
                    criminalConviction: {
                        hasCriminalConviction: false,
                        description: ""
                    }
                }
            }
        },
        validations: {
            personalInfo: {
                firstName: {
                    required
                },
                lastName: {
                    required
                },
                birthDate: {
                    required
                },
                birthCertificateNumber: {
                    required,
                    numeric
                },
                ssn: {
                    required,
                    numeric
                },
                placeOfBirth: {
                    required
                },
                gender: {
                    required
                },
                placeOfIssueBirthCertificate: {
                    required
                },
                militaryServiceInfo: {
                    militaryCondition: {
                        required: requiredIf(function () {
                            return this.personalInfo.gender == 0
                        })
                    },
                    exemptionType: {
                        required: requiredIf(function () {
                            return this.personalInfo.militaryServiceInfo.hasExemptionDocument == 'true'
                        })
                    },
                },
                familyInfo: {
                    fatherName: {
                        required
                    },
                    maritalStatus: {
                        required
                    },
                    spouseName: {
                        required: requiredIf(function () {
                            return this.personalInfo.familyInfo.maritalStatus == 0
                        })
                    },
                    spouseJob: {
                        required: requiredIf(function () {
                            return this.personalInfo.familyInfo.maritalStatus == 0
                        })
                    },
                    numberOfUnderTheTutelagePeople: {
                        required
                    },
                    numberOfChildren: {
                        required
                    },
                },
                residenceInfo: {
                    address: {
                        required
                    },
                    phoneNumber: {
                        required
                    },
                    typeOfOwnershipOfTheResidence: {
                        required
                    },
                    rentAmount: {
                        required: requiredIf(function () {
                            return this.personalInfo.residenceInfo.typeOfOwnershipOfTheResidence == 0
                        }),
                    }
                },
                contactInfo: {
                    phoneNumber: {
                        required
                    },
                    email: {
                        required,
                        email
                    },
                },
                pastRelationWithCompany: {
                    description: {
                        required: requiredIf(function () {
                            return this.personalInfo.pastRelationWithCompany.hasRelation == 'true'
                        })
                    }
                },
                criminalConviction: {
                    description: {
                        required: requiredIf(function () {
                            return this.personalInfo.criminalConviction.hasCriminalConviction == 'true'
                        })
                    }
                }
            },
            form: ['personalInfo']
        },
        methods: {
            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid
                this.$emit('on-validate', this.$data, isValid)
                return isValid
            },
            changeGender() {
                this.personalInfo.militaryServiceInfo.militaryCondition = null;
                this.personalInfo.militaryServiceInfo.hasExemptionDocument = false;
                this.personalInfo.militaryServiceInfo.exemptionType = '';
            },
            changeMaritalStatus() {
                this.personalInfo.familyInfo.spouseName = '';
                this.personalInfo.familyInfo.spouseJob = '';
                this.personalInfo.familyInfo.spouseWorkplacePhoneNumber = '';
            },
            changeTypeOfOwnershipOfTheResidence() {
                this.personalInfo.residenceInfo.rentAmount = '';
            },
            changePastRelationWithCompany() {
                this.personalInfo.pastRelationWithCompany.description = '';

            },
            changeCriminalConviction() {
                this.personalInfo.criminalConviction.description = '';
            }
        },
    }
</script>
